import { axios } from '@/services/axios';

/**
 * Creates or updates the SSO config.
 * Uses PUT when an existing id is provided, POST otherwise.
 */
const saveSSOConfig = async (sso) => {
    if (sso.id) {
        const res = await axios.put('/sso', sso);
        return res.data;
    }
    const res = await axios.post('/sso', sso);
    return res.data;
};

export default saveSSOConfig;
